"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApolloProvider = void 0;
var _tslib = require("apollo-stack-hubspot/internal/tslib/tslib");
var _index = require("apollo-stack-hubspot/@apollo/client/utilities/globals/index");
var React = _interopRequireWildcard(require("react"));
var _ApolloContext = require("apollo-stack-hubspot/@apollo/client/react/context/ApolloContext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ApolloProvider = exports.ApolloProvider = function ApolloProvider(_a) {
  var client = _a.client,
    children = _a.children;
  var ApolloContext = (0, _ApolloContext.getApolloContext)();
  var parentContext = React.useContext(ApolloContext);
  var context = React.useMemo(function () {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, parentContext), {
      client: client || parentContext.client
    });
  }, [parentContext, client]);
  (0, _index.invariant)(context.client, 47);
  return /*#__PURE__*/React.createElement(ApolloContext.Provider, {
    value: context
  }, children);
};